const userAgent = navigator.userAgent || navigator.vendor || window.opera

export default {
  is: {
    mobile: /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent),
    desktop: !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent),
    ios: /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream,
    android: /android/i.test(userAgent),
    windows: /Win/.test(userAgent),
    mac: /Mac/i.test(userAgent) && !/iPhone|iPod|iPad/.test(userAgent),
    linux: /Linux/i.test(userAgent),
    firefox: /firefox/i.test(userAgent),
    chrome: /chrome|crios|crmo/i.test(userAgent),
    safari: /safari/i.test(userAgent) && !/chrome|crios|crmo/i.test(userAgent),
    edge: /edg/i.test(userAgent),
  },
  has: {
    touch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
  },
}
